import React, { useEffect, useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./EditVideo.module.css";
import { TextArea } from "../../Component/TextArea";
import { RxCross2 } from "react-icons/rx";
import { Input } from "../../Component/Input/Input";
import { Button } from "../../Component/Button/Button";
const EditVideo = ({
  show,
  setShow,
  width,
  selectedItem,
  handleEdit,
  isLoadingEdit,
}) => {
  const [active, setactive] = useState("original");
  const [text, setText] = useState("" || selectedItem?.description);

  useEffect(() => {
    if (text?.split(" ").filter((item) => item != "")?.length == 5) {
      setText((prev) => prev.slice(0, -1));
    }
  }, [text]);

  return (
    <div>
      <ModalSkeleton
        setShow={setShow}
        show={show}
        width={width}
        //   header={"Login"}
        borderRadius={"20px"}
        //   showCloseIcon
      >
        <div className={classes.main}>
          <div className={classes.header}>
            <div
              className={[
                classes.btn,
                active === "original" && classes.active,
              ].join(" ")}
              onClick={() => {
                setactive("original");
              }}
            >
              <h3 className={classes.heading}>
                Descriptions (
                {text.split(" ").filter((item) => item != "")?.length})
              </h3>
              <div
              //   className={classes.input_main}
              >
                <TextArea
                  customStyle={{ color: "#7B7B7B", borderColor: "#00000029" }}
                  value={text}
                  setter={(e) => {
                    if (
                      text.split(" ").filter((item) => item != "")?.length < 5
                    ) {
                      return setText(e);
                    } else {
                      // return setText(e);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          {/* <div
            className={classes.crossBtn}
            onClick={() => {
              setShow(false);
            }}
          >
            <RxCross2 size={20} color={"var(--white-color"} />
          </div> */}
          <div>
            <Button
              disabled={isLoadingEdit}
              green
              label={isLoadingEdit ? "Wait..." : "Update"}
              onClick={() =>
                handleEdit({ _id: selectedItem?._id, description: text })
              }
            />
          </div>
        </div>
      </ModalSkeleton>
    </div>
  );
};

export default EditVideo;
